import { store } from '@store/redux/store';

export const updateBeamUrl = (url: string): string => {
  const { auth } = store.getState();
  if (url) {
    if (url.includes('cloudfront.net')) {
      return `${url}${url.includes('?') ? '&' : '?'}Policy=${
        auth.cookiePolicy
      }&Key-Pair-Id=${auth.cookieKeyId}&Signature=${auth.cookieSignature}`;
    }
    if (url.includes('http:') && url.includes('.pdf')) {
      return url;
    }
    if (url.includes('http:')) {
      return `${process.env.REACT_APP_HTTP_PROXY_URL as string}?url=${
        url.includes('?') ? url.split('?')[0] : url
      }`;
    }
  }
  return url;
};

export const extractUrl = (url: string): string => {
  if (url) {
    if (url.includes('cloudfront.net')) {
      return url.split('?')[0];
    }
    if (url.includes('url=')) {
      return url.split('url=')[1];
    }
  }
  return url;
};
